import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AppRoutes from './routes/AppRoutes';
import { UIProvider } from './shared/UI/Uicontext';
import { useAuthKey } from './store/api/authKey';
import { AppDispatch } from './store';
import { loadSession } from './store/slices/sessionSlice';
import { decodeSessionFromStorage } from './shared/services/userSessionService';

function App() {
  useAuthKey();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const session = decodeSessionFromStorage();
    if (session) dispatch(loadSession(session));
  }, [dispatch]);

  return (
    <UIProvider>
      <AppRoutes />
    </UIProvider>
  );
}

export default App;
